export const isSafari = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  return userAgent.includes('safari') || userAgent.includes('applewebkit');
};

export const isIphone = () => {
  const userAgent = navigator.userAgent.toLocaleLowerCase();
  return userAgent.includes('iphone');
};
